import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import {
  columnDataset, columnProject, columnName,
} from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import TableWrapper from '@/components/table/TableWrapper';
import ActionDialogContent from '@/components/dialogs/ActionDialogContent';
import { hideDeleteRequest, deleteRequests } from '../actions';
import RequestsTableColumns from '../components/RequestsTableColumns';
import RequestsTableRows from './RequestsTableRows';

const RequestDeletionDialog = ({
  deleteData,
  hide,
  results,
  theme,
}) => (
  <ActionDialogContent
    inProgress={results.some((result) => result.destroyStatus === states.PENDING)}
    items={results}
    hide={hide}
    theme={theme}
    onSubmit={deleteData}
    entity="request"
    entities="requests"
    className="aridhia-request-deletion-dialog"
    icon="key"
  >
    <div className="aridhia-dialog-table-container">
      <TableWrapper sticky celled className="aridhia-requests-table">
        <Table.Header fullWidth>
          <RequestsTableColumns items={results} columns={[columnName, columnProject, columnDataset]} />
        </Table.Header>
        <Table.Body>
          <RequestsTableRows items={results} columns={[columnName, columnProject, columnDataset]} />
        </Table.Body>
      </TableWrapper>
    </div>
  </ActionDialogContent>
);

const mapStateToProps = ({
  requests: { requests: { deletion: { results } } },
}) => ({
  results,
});

const mapDispatchToProps = {
  hide: hideDeleteRequest,
  deleteData: deleteRequests,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestDeletionDialog);
